import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreatePericiaRequest extends CreateKeyValueRequest{
  notificacionRealizada!: boolean;
  lugar!: string;
  activo!: boolean;
  fechaRealizada!: Date;
  fechaPropuesta!: Date;
  idExpediente!: number;
  idEstadoPericia!: number;
  idTipoPericia!: number;
  urlReunion!: string;
  fechaCedulaPresentacion!: Date;
  fechaVencePresentacion!: Date;
  fechaAceptaCargo!: Date;
  fechaProponePericia!: Date;
  fechaRealizaPericia!: Date;
}
